import { motion } from "framer-motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SITE } from "@/data/site";

export const FAQ = () => {
  return (
    <section id="sss" className="py-24 lg:py-32 bg-white">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-4"
        >
          <span className="eyebrow">Yardım</span>
          <h2 className="font-display text-4xl lg:text-5xl mt-3 text-[hsl(var(--nl-anthracite))]">
            Sık Sorulan <em className="not-italic font-serif italic gold-text">Sorular</em>
          </h2>
          <div className="gold-line mt-5" />
          <p className="text-sm text-[hsl(var(--muted-foreground))] mt-6">
            Yanıtını bulamadığınız bir soru mu var? WhatsApp üzerinden bize ulaşmaktan çekinmeyin.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="lg:col-span-8"
        >
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {SITE.faq.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-[hsl(var(--nl-line))]"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="font-serif text-lg lg:text-xl text-[hsl(var(--nl-anthracite))] hover:no-underline hover:gold-text py-6 text-left">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[15px] leading-[1.8] text-[hsl(var(--muted-foreground))] pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;
